import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import CompanyInfo from "@/pages/medewerkers/$userId/zakelijke_gegevens/CompanyInfo"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/zakelijke_gegevens/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data } = useCurrentUserSuspenseQuery()

  return <CompanyInfo userId={Number(data?.data.userId)} pageType="profile" />
}
